import React, { Component } from 'react';
import actions from '../../redux/actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Select from 'react-select';
import _sumBy from 'lodash/sumBy';
import _sortBy from 'lodash/sortBy';
import _orderBy from 'lodash/orderBy';
import _findIndex from 'lodash/findIndex';
import _isEqual from 'lodash/isEqual';
import _reverse from 'lodash/reverse';

class SearchResultsSort extends Component {
    constructor(props) {
        super(props);
        this.orderOptions = [ { value: 'price', label: 'Price' }, { value: 'rating', label: 'Star Rating' } ];
        this.onOrderDirectionChange = this.onOrderDirectionChange.bind(this);
        this.onOrderOptionChange = this.onOrderOptionChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        const {actions} = this.props;
        if (this.props.searchId !== prevProps.searchId && this.props.isSortEmpty)
            actions.applySorting({ orderBy: { value: 'price', label: 'Price' }, orderAsc: true});
    }

    onOrderOptionChange(selected) {
        const {actions} = this.props;
        actions.applySorting({ orderBy: selected }).then((data)=>this.sortData(data));
    }

    onOrderDirectionChange() {
        const {actions, searchSort:{ orderAsc }} = this.props;
        actions.applySorting({ orderAsc: !orderAsc }).then((data)=>this.sortData(data));
    }

    sortData(data){
        const { searchData, actions} = this.props;
        const sortByPrice = `TotalAdultPrice + TotalChildPrice ${data.orderAsc ? 'asc' : 'desc'}`;
        const sortByStars = `RatePlan.Hotel.StarRating.Name[0] ${data.orderAsc ? 'asc' : 'desc'}, TotalAdultPrice + TotalChildPrice asc`;
        const sortMethod = data.orderBy.value === 'price' ? sortByPrice : sortByStars;
        const req = {
            ...searchData,
            pageNumber: 0,
            sortExpression: sortMethod
        };
        actions.getHotelAvailabilityXmlRequest(req);
    }

    render() {
        const {searchSort:{orderBy, orderAsc}, isLoading, isSearchTriggered} = this.props;
        return (
            <div className="travco-search-sorting-wrapper">
                <span className="tss-title">Order by:</span>
                <div className="tss-dropDown">
                    <Select options={this.orderOptions} value={orderBy} onChange={this.onOrderOptionChange} isDisabled={isLoading || !isSearchTriggered}/>
                </div>
                <button className="travco-btn-secondary small" type="button" onClick={this.onOrderDirectionChange} disabled={isLoading || !isSearchTriggered}>
                    {orderAsc ? 'Asc' : 'Desc'}
                </button>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const isLoading = state.pendingTasks > 0;
    const isSortEmpty = !state.xml?.requestHAData?.sortExpression;
    const isSearchTriggered = !!state.xml?.requestHAData?.searchQueryId;
    return {
        searchId: state.xml?.requestHAData?.searchQueryId || '',
        searchData: state.xml?.requestHAData || {},
        searchSort: state.searchSort,
        isSearchTriggered,
        isLoading,
        isSortEmpty
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultsSort);
